import { reviewsTypes } from './actions';

const initialState = {
  reviews: [],
  reviewsStats: {
    averageRating: 0,
    totalReviews: 0,
    totalRatings: 0,
    ratingDistribution: {},
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case reviewsTypes.GET_REVIEWS.SUCCESS:
      return {
        ...state,
        reviews: action.payload.reviews || [],
        reviewsStats: {
          averageRating: action.payload.averageRating || 0,
          totalReviews: action.payload.totalReviews || 0,
          totalRatings: action.payload.totalRatings || 0,
          ratingDistribution: action.payload.ratingDistribution || {},
        },
      };
    case reviewsTypes.REPORT_REVIEW.SUCCESS:
      return {
        ...state,
        reviews: state.reviews.map((review) =>
          review.id_recensione === action.payload.reviewId
            ? { ...review, segnalata: 1 }
            : review,
        ),
      };
    default:
      return { ...state };
  }
};
